import deLocale from 'element-ui/lib/locale/lang/de'
import home from './de/home'

const de = {
    language: 'Deutsch',
    message: {
        'home': {
            ...home,
            'enterEmail': 'Bitte E-Mail eingeben',
            'save': 'Speichern',
            'saveSuccess': 'Erfolgreich gespeichert',
            'pointHistory': 'Punkteverlauf',
            'type': 'Typ',
            'remark': 'Bemerkung',
            'pendingComment': 'Zu bewerten',
            'commented': 'Bewertet',
            'selectDate': 'Datum auswählen',
            'loginSuccess': 'Anmeldung erfolgreich',
            'loginFail': 'Anmeldung fehlgeschlagen',
            'close': 'Schließen',
            'required': 'Erforderlich',
            'nickname': 'Spitzname',
            'enterNickname': 'Bitte Spitznamen eingeben',
            'gender': 'Geschlecht',
            'male': 'Männlich',
            'female': 'Weiblich',
            'secret': 'Geheim',
            'birthday': 'Geburtstag',
            checkoutLoadFailed: 'Kasseninformationen konnten nicht geladen werden. Bitte später erneut versuchen.',
            checkoutErrorTitle: 'Hinweis',
            goAddAddress: 'Lieferadresse hinzufügen',
            shop_order_selectOrAddAddress: 'Bitte fügen Sie zuerst eine Lieferadresse hinzu und legen Sie sie als Standard fest, bevor Sie zur Kasse gehen.',
            shop_order_cartEmpty: 'Der Warenkorb ist leer, Kasse nicht möglich.',
            shop_order_cartHasNotActive: 'Es gibt nicht gelistete oder ungültige Artikel, Kasse nicht möglich.',
            shop_order_cartHasNotMarketable: 'Einige Artikel sind nicht mehr verfügbar, Kasse nicht möglich.',
            shop_order_cartHasLowStock: 'Nicht genügend Lagerbestand, Kasse nicht möglich.',
            shop_order_cartHasExpiredGoods: 'Einige Artikel im Shop sind abgelaufen, Kasse nicht möglich.',
            shop_order_typeIsNull: 'Bestelltyp konnte nicht erkannt werden, bitte Artikeltyp prüfen.',
            shop_order_goodsNotFound: 'Produktinformationen existieren nicht oder wurden gelöscht.',
            shop_order_giftNotForSale: 'Geschenkartikel können nicht direkt gekauft werden.',
            common_message_badRequest: 'Ungültige Anfrage, bitte Produkt und Parameter prüfen.',
        },
    },
    '手机号码最小长度为8位': 'Die Mindestlänge der Mobiltelefonnummer beträgt 8 Ziffern',
    '邮箱账号名称最小长度为6位': 'Die Mindestlänge des E-Mail-Kontonamens beträgt 6 Zeichen',
    '邮箱只能包含英文，数字等字符': 'Die Mailbox darf nur Zeichen wie Englisch und Zahlen enthalten',
    '请选择正确的收货地址': 'Bitte wählen Sie die richtige Lieferadresse',
    // ===== Data Dictionary I18N =====
    Dict_language_status_0: 'Deaktiviert',
    Dict_language_status_1: 'Aktiviert',
    Dict_member_label_type_1: 'Bedingungs-Label',
    Dict_member_label_type_2: 'Manuelles Label',
    Dict_member_level_type_0: 'Verbrauchsstufe (LV)',
    Dict_member_level_type_1: 'Bezahltes Mitglied (VIP)',
    Dict_member_growth_action_type_1: 'Bestellung aufgeben',
    Dict_member_growth_action_type_2: 'Tägliche Anmeldung',
    Dict_member_growth_action_type_3: 'Bewertung abgeben',
    Dict_member_growth_action_type_4: 'Profil vervollständigen',
    Dict_paid_member_payment_type_0: 'Guthaben-Zahlung',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Gültig',
    Dict_paid_member_record_status_1: 'Abgelaufen',
    Dict_paid_member_record_status_2: 'Erstattet',
    Dict_point_lottery_prize_type_0: 'Punkte',
    Dict_point_lottery_prize_type_1: 'Gutschein',
    Dict_point_lottery_prize_type_2: 'Sachpreis',
    Dict_point_lottery_prize_type_3: 'Danke fürs Mitmachen',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-Mail',
    Dict_notification_channel_type_2: 'Interne Nachricht',
    Dict_notification_channel_type_3: 'Push-Benachrichtigung',
    Dict_announcement_status_0: 'Entwurf',
    Dict_announcement_status_1: 'Veröffentlicht',
    Dict_announcement_status_2: 'Zurückgezogen',
    Dict_live_permission_status_0: 'Nicht beantragt',
    Dict_live_permission_status_1: 'In Prüfung',
    Dict_live_permission_status_2: 'Aktiviert',
    Dict_live_permission_status_3: 'Abgelehnt',
    Dict_live_room_status_0: 'Nicht begonnen',
    Dict_live_room_status_1: 'Live',
    Dict_live_room_status_2: 'Beendet',
    Dict_live_room_status_3: 'Abnormal unterbrochen',
    Dict_live_room_type_0: 'Plattform-Live',
    Dict_live_room_type_1: 'Händler-Live',
    Dict_store_type_0: 'Einzelshop',
    Dict_store_type_1: 'Unternehmensshop',
    Dict_store_sign_status_0: 'Zu unterzeichnen',
    Dict_store_sign_status_1: 'Unterzeichnet',
    Dict_store_sign_status_2: 'Gekündigt',
    Dict_store_business_change_status_0: 'Zu prüfen',
    Dict_store_business_change_status_1: 'Genehmigt',
    Dict_store_business_change_status_2: 'Abgelehnt',
    Dict_decoration_page_type_0: 'Startseite',
    Dict_decoration_page_type_1: 'Kategorieseite',
    Dict_decoration_page_type_2: 'Aktionsseite',
    Dict_decoration_page_type_3: 'Benutzerdefinierte Seite',
    Dict_decoration_status_0: 'Entwurf',
    Dict_decoration_status_1: 'Veröffentlicht',
    Dict_decoration_popup_trigger_page_0: 'Plattform-Startseite',
    Dict_decoration_popup_trigger_page_1: 'Mitgliederbereich',
    Dict_decoration_popup_trigger_page_2: 'Zahlung erfolgreich',
    Dict_decoration_popup_target_user_0: 'Alle Nutzer',
    Dict_decoration_popup_target_user_1: 'Kostenlose Mitglieder',
    Dict_decoration_popup_target_user_2: 'Bezahlte Mitglieder',
    Dict_decoration_popup_frequency_0: 'Einmal dauerhaft',
    Dict_decoration_popup_frequency_1: 'Bei jedem Besuch',
    Dict_decoration_popup_frequency_2: 'Benutzerdefinierte Häufigkeit',
    Dict_track_event_type_page_view: 'Seitenaufruf',
    Dict_track_event_type_click: 'Klick',
    Dict_track_event_type_add_to_cart: 'In den Warenkorb',
    Dict_track_event_type_search: 'Suche',
    Dict_track_event_type_purchase: 'Kauf',
    Dict_track_event_type_live_watch: 'Live ansehen',
    Dict_reconcile_period_type_0: 'Täglich',
    Dict_reconcile_period_type_1: 'Wöchentlich',
    Dict_reconcile_period_type_2: 'Monatlich',
    Dict_store_settlement_status_0: 'Abrechnung ausstehend',
    Dict_store_settlement_status_1: 'Abgerechnet',
    Dict_distributor_status_0: 'Zu prüfen',
    Dict_distributor_status_1: 'Geprüft',
    Dict_distributor_status_2: 'Abgelehnt',
    Dict_distribution_commission_type_0: 'Direkte Provision',
    Dict_distribution_commission_type_1: 'Indirekte Provision',
    Dict_configuration_status_0: 'Deaktiviert',
    Dict_configuration_status_1: 'Aktiviert',
    ...deLocale
}

export default de
